/* Empty-cart recommendations; native cart sections remain the source of truth. */
(() => {
  if (window.ctEmptyCartProductsReady) return;
  window.ctEmptyCartProductsReady = true;
  let busy = false;
  const rows = () => document.querySelectorAll('[data-ct-empty-item]');
  const choice = (row) => {
    const control = row.querySelector('[data-ct-empty-variant]');
    if (!control || !/^\d+$/.test(control.value)) return null;
    if (control.tagName === 'SELECT') {
      const option = control.selectedOptions[0];
      if (!option || option.disabled) return null;
      return { id: control.value, price: option.dataset.ctEmptyPrice };
    }
    return { id: control.value };
  };
  const enhance = () => {
    rows().forEach((row) => {
      const controls = row.querySelector('[data-ct-empty-controls]');
      const button = row.querySelector('[data-ct-empty-add]');
      const variant = row.querySelector('[data-ct-empty-variant]');
      if (!controls || !button || !variant) return;
      controls.hidden = false;
      const fallback = row.querySelector('[data-ct-empty-fallback]');
      if (fallback) fallback.hidden = true;
      variant.disabled = busy;
      button.disabled = busy || !choice(row);
    });
  };
  const cartUrl = () => {
    const url = new URL(window.routes.cart_url, window.location.origin);
    url.search = window.location.search;
    return url;
  };
  const parse = (html, selector) => typeof html === 'string'
    ? new DOMParser().parseFromString(html, 'text/html').querySelector(selector) : null;
  const surfaces = () => {
    const drawer = document.querySelector('cart-drawer');
    const page = document.querySelector('cart-items');
    const sections = [];
    if (drawer) sections.push(...drawer.getSectionsToRender());
    if (page) sections.push(...page.getSectionsToRender());
    const ids = [...new Set(sections.map((section) => section.section || section.id))];
    if (!ids.length || ids.length > 5) throw new Error('Cart sections unavailable');
    return { drawer, page, sections, ids };
  };
  const usable = (sections, ui) => sections && ui.sections.every((section) => {
    const id = section.section || section.id;
    return parse(sections[id], section.selector || '.shopify-section');
  }) && (!ui.page || (parse(sections[ui.page.getSectionsToRender()[0].section], 'cart-items')
    && parse(sections[ui.page.getSectionsToRender().find((section) => section.id === 'main-cart-footer').section], '#main-cart-footer')));
  const render = (sections, ui, variantId, row, origin) => {
    const drawerOpen = ui.drawer && ui.drawer.classList.contains('active');
    if (ui.drawer) {
      ui.drawer.renderContents({ sections }, { open: false });
      const source = parse(sections['cart-drawer'], '#CartDrawer');
      ui.drawer.classList.toggle('is-empty', !!source.querySelector('.drawer__inner-empty'));
    }
    if (ui.page) {
      const pageSections = ui.page.getSectionsToRender();
      const main = pageSections.find((section) => section.id === 'main-cart-items');
      const source = parse(sections[main.section || main.id], 'cart-items');
      ui.page.innerHTML = source.innerHTML;
      ui.page.setAttribute('class', source.getAttribute('class') || '');
      pageSections.filter((section) => section.id !== 'main-cart-items').forEach((section) => {
        const target = document.getElementById(section.id);
        if (!target || (ui.drawer && ['cart-icon-bubble', 'CartDrawer'].includes(section.id))) return;
        const html = sections[section.section || section.id];
        if (section.id === 'main-cart-footer') {
          const footer = parse(html, '#main-cart-footer');
          target.innerHTML = footer.innerHTML;
          target.classList.toggle('is-empty', footer.classList.contains('is-empty'));
        } else target.innerHTML = parse(html, section.selector || '.shopify-section').innerHTML;
      });
    }
    // Native controllers cache this node in their constructors. Rebind after
    // replacing both surfaces so later quantity/remove announcements stay live.
    const lineStatus = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    document.querySelectorAll('cart-items, cart-drawer-items').forEach((controller) => {
      controller.lineItemStatusElement = lineStatus;
    });
    const scope = drawerOpen ? ui.drawer : (origin === 'page' ? ui.page : null);
    if (scope) {
      const line = scope.querySelector('[data-quantity-variant-id="' + variantId + '"]');
      const name = (line && line.closest('.cart-item').querySelector('.cart-item__name'))
        || scope.querySelector('.cart-item__name');
      const target = name || scope.querySelector('[data-sbc-cart-heading]');
      if (target) {
        if (drawerOpen && typeof trapFocus === 'function') trapFocus(ui.drawer.querySelector('.drawer__inner'), target);
        else target.focus();
      }
    }
    const status = drawerOpen ? ui.drawer.querySelector('[data-sbc-status]') : document.getElementById('shopping-cart-line-item-status');
    if (status) {
      status.setAttribute('aria-hidden', 'false');
      status.textContent = row.dataset.ctEmptyAdded || 'Added to cart';
    }
  };
  document.addEventListener('change', (event) => {
    const control = event.target.closest('[data-ct-empty-variant]');
    if (!control) return;
    event.stopPropagation();
    const row = control.closest('[data-ct-empty-item]');
    const selected = choice(row);
    if (selected && selected.price) row.querySelector('[data-ct-empty-price-display]').textContent = selected.price;
    const error = row.querySelector('[data-ct-empty-error]');
    if (error) error.hidden = true;
    enhance();
  }, true);
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-ct-empty-add]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const row = button.closest('[data-ct-empty-item]');
    const selected = choice(row);
    if (busy || button.disabled || !selected) return;
    const ui = surfaces();
    const origin = row.closest('cart-drawer') ? 'drawer' : 'page';
    const label = button.textContent;
    const error = row.querySelector('[data-ct-empty-error]');
    let redirecting = false;
    busy = true;
    enhance();
    button.setAttribute('aria-busy', 'true');
    button.textContent = row.dataset.ctEmptyAdding || 'Adding…';
    if (error) error.hidden = true;
    try {
      const body = new FormData();
      body.append('id', selected.id);
      body.append('quantity', '1');
      body.append('sections', ui.ids.join(','));
      body.append('sections_url', window.location.pathname + window.location.search);
      const response = await fetch(window.routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body });
      const added = await response.json();
      if (!response.ok || added.status) {
        if (response.status !== 422) throw new Error('Uncertain add response');
        if (error) { error.textContent = typeof added.description === 'string' ? added.description : (row.dataset.ctEmptyGenericError || 'Unable to add this item. Please try again.'); error.hidden = false; }
        return;
      }
      const readUrl = cartUrl();
      readUrl.pathname = readUrl.pathname.replace(/\/$/, '') + '.js';
      const cartResponse = await fetch(readUrl.toString(), { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!cartResponse.ok) throw new Error('Cart read failed');
      const cart = await cartResponse.json();
      if (!Array.isArray(cart.items) || typeof cart.item_count !== 'number') throw new Error('Invalid cart data');
      let sections = added.sections;
      if (!usable(sections, ui)) {
        const refresh = cartUrl();
        refresh.searchParams.set('sections', ui.ids.join(','));
        const sectionResponse = await fetch(refresh.toString(), { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!sectionResponse.ok) throw new Error('Section read failed');
        sections = await sectionResponse.json();
      }
      if (!usable(sections, ui)) throw new Error('Invalid cart sections');
      render(sections, ui, selected.id, row, origin);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart, productVariantId: selected.id });
      }
    } catch (_) {
      // Never retry an uncertain write: the cart page resolves the current state.
      redirecting = true;
      window.location.assign(cartUrl().toString());
    } finally {
      if (!redirecting) {
        busy = false;
        button.removeAttribute('aria-busy');
        button.textContent = label;
        enhance();
      }
    }
  }, true);
  const start = () => {
    enhance();
    new MutationObserver(enhance).observe(document.body, { childList: true, subtree: true });
  };
  Promise.all(['cart-items', 'cart-drawer'].map((name) => customElements.whenDefined(name))).then(start);
})();
